import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import api from "../api"
import { AssignToLocationRequest } from "../api/fulfillment.api"

export interface FufillmentListState {
    fulfillmentRequests: []
    fulfilledParcels: []
    fulfillmentSuites: []
    loading: boolean
    //TODO: make error interface
    error?: Record<string, any>
    success?: boolean
    tab?: string
    barcode?: string
}

const initialState: FufillmentListState = {
    fulfillmentRequests: [],
    fulfilledParcels: [],
    fulfillmentSuites: [],
    loading: false,
    tab: "fulfillmentRequests"
}

export const loadFulfillmentRequests = createAsyncThunk(
    "fulfillment/list",
    async ({ warehouse }: { warehouse: string }, thunkAPI) => {
        try {
            return await api.fulfillment.listFulfillmentRequests({ warehouse })
        } catch (error: any) {
            console.log(error)

            return error.message
        }
    }
)

export const loadFulfilledParcels = createAsyncThunk(
    "fulfillment/parcels-list",
    async ({ warehouse }: { warehouse: string }, thunkAPI) => {
        try {
            return await api.fulfillment.listFulfilledParcels({ warehouse })
        } catch (error: any) {
            console.log(error)

            return error.message
        }
    }
)

export const assignToLocation = createAsyncThunk(
    "fulfillment/assign",
    async (assignToLocationData: AssignToLocationRequest, thunkAPI) => {
        try {
            return await api.fulfillment.assignToLocation(assignToLocationData)
        } catch (error: any) {
            return thunkAPI.rejectWithValue(error)
        }
    }
)

export const createParcel = createAsyncThunk(
    "fulfillment/create-parcel",
    async (parcelId: number, thunkAPI) => {
        try {
            return await api.fulfillment.createParcel({ parcelId })
        } catch (error: any) {
            return thunkAPI.rejectWithValue(error)
        }
    }
)

//listFulfillmentSuites
export const loadFulfillmentSuites = createAsyncThunk(
    "fulfillment/suites-list",
    async ({ warehouse }: { warehouse: string }, thunkAPI) => {
        try {
            return await api.fulfillment.listFulfillmentSuites({ warehouse })
        } catch (error: any) {
            console.log(error)

            return error.message
        }
    }
)

export const fulfillmentsSlice = createSlice({
    name: "fulfillment",
    initialState,

    reducers: {
        clearError: (state: FufillmentListState) => {
            state.error = undefined
        },
        resetSuccess: (state: FufillmentListState) => {
            state.success = undefined
        },
        setTab: (state: FufillmentListState, action: any) => {
            state.tab = action.payload
        }
    },

    extraReducers: {
        [loadFulfillmentRequests.pending.toString()]: (state, action) => {
            state.loading = true
        },
        [loadFulfillmentRequests.rejected.toString()]: (state, action) => {
            state.loading = false
            if (action.payload?.data?.data?.error) {
                state.error = action.payload?.data?.error
            } else {
                state.error = action.payload?.data?.payload
            }
        },
        [loadFulfillmentRequests.fulfilled.toString()]: (state, action) => {
            state.loading = false
            state.fulfillmentRequests = action.payload?.data?.payload || []
        },

        [loadFulfilledParcels.pending.toString()]: (state, action) => {
            state.loading = true
        },
        [loadFulfilledParcels.rejected.toString()]: (state, action) => {
            state.loading = false
            if (action.payload?.data?.data?.error) {
                state.error = action.payload?.data?.error
            } else {
                state.error = action.payload?.data?.payload
            }
        },
        [loadFulfilledParcels.fulfilled.toString()]: (state, action) => {
            state.loading = false
            state.fulfilledParcels = action.payload?.data?.payload || []
        },

        [assignToLocation.pending.toString()]: (state, action) => {
            state.loading = true
        },
        [assignToLocation.rejected.toString()]: (state, action) => {
            state.loading = false
            if (action.payload?.response?.data?.data?.payload) {
                state.error = { payload: action.payload?.response?.data?.data?.payload }
            } else if (action.payload?.response?.data?.payload) {
                state.error = { payload: action.payload?.response?.data?.payload }
            } else if (action.payload?.response?.data?.data?.error) {
                state.error = { error: action.payload?.response?.data?.data?.error }
            } else {
                state.error = { error: action.payload?.response?.data?.error }
            }
        },
        [assignToLocation.fulfilled.toString()]: (state, action) => {
            state.loading = false
            state.success = true
        },
        [createParcel.pending.toString()]: (state, action) => {
            state.loading = true
        },
        [createParcel.rejected.toString()]: (state, action) => {
            state.loading = false
            if (action.payload?.response?.data?.data?.payload) {
                state.error = { payload: action.payload?.response?.data?.data?.payload }
            } else if (action.payload?.response?.data?.payload) {
                state.error = { payload: action.payload?.response?.data?.payload }
            } else if (action.payload?.response?.data?.data?.error) {
                state.error = { error: action.payload?.response?.data?.data?.error }
            } else {
                state.error = { error: action.payload?.response?.data?.error }
            }
        },
        [createParcel.fulfilled.toString()]: (state, action) => {
            const payload = action.payload?.data?.payload || {}
            state.loading = false
            state.success = true
            state.barcode = payload?.barcode_page || ""
        },

        [loadFulfillmentSuites.pending.toString()]: (state, action) => {
            state.loading = true
        },
        [loadFulfillmentSuites.rejected.toString()]: (state, action) => {
            state.loading = false
            if (action.payload?.data?.data?.error) {
                state.error = action.payload?.data?.error
            } else {
                state.error = action.payload?.data?.payload
            }
        },
        [loadFulfillmentSuites.fulfilled.toString()]: (state, action) => {
            state.loading = false
            state.fulfillmentSuites = action.payload?.data?.payload || []
        }
    }
})

export const { clearError, resetSuccess, setTab } = fulfillmentsSlice.actions

export default fulfillmentsSlice.reducer
